<main role="main" class="pre-loader welcome">
  <section>
    <h1>Welcome to the AmiLearn Learning Portal</h1>
    <p>Not a user? <a href="https://www.amilearn.ca">Find out more</a></p>
    <p>Need Support? Contact <a href="mailto:support@meetami.ca">support@meetami.ca</a>.</p>
  </section>
</main>
